<div class="hero">
  @if(country?.medias!.length > 0){ @if(loading){
  <div class="placeholder">
    <i class="pi pi-spin pi-spinner yellow text-lg"></i>
  </div>
  }@else{
  <div class="gradient"></div>
  <img [src]="(country?.medias)![0].media | imagePipe : 'travel' : 'lg'" />
  } }@else{
  <div class="placeholder">
    @if(loading){
    <i class="pi pi-spin pi-spinner yellow text-lg"></i>
    }@else {
    <img src="/assets/media/icons/photos.png" />
    }
  </div>
  }
</div>
<div class="container">
  <form [formGroup]="frmSearch" (ngSubmit)="submitSearch()">
    <div class="search grid">
      <div class="banner">
        <h1>Viaggi di gruppo {{ country?.name }}</h1>
        <span>Scopri i viaggi della community di Social Travels</span>
      </div>

      <div class="col-12 md:col">
        <div class="search-input">
          <p-multiSelect
            styleClass="w-full"
            [options]="types"
            optionLabel="name"
            optionValue="id"
            [showClear]="true"
            formControlName="categories"
            placeholder="Categorie"
            emptyMessage="Nessun risultato trovato."
          >
            <ng-template let-t pTemplate="type">
              <div class="flex align-items-center gap-2">
                <img [src]="t.id | travelType" />
                <span>{{ t.name }}</span>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col">
        <p-calendar
          formControlName="month"
          view="month"
          dateFormat="mm/yy"
          placeholder="Mese di partenza"
          panelStyleClass="custom-calendar"
          [touchUI]="false"
          [readonlyInput]="true"
          [minDate]="today"
          [showClear]="true"
          appendTo="body"
        ></p-calendar>
      </div>
      <div class="col-12 md:col">
        <p-autoComplete
          formControlName="leader"
          styleClass="w-full"
          [suggestions]="suggestedLeaders"
          (completeMethod)="filterLeaders($event)"
          placeholder="Organizzatore"
          dataKey="id"
          [forceSelection]="true"
          emptyMessage="Nessun risultato"
          emptyFilterMessage="Nessun risultato trovato"
          [optionLabel]="getLeadersNameToDisplay"
        >
          <ng-template let-leader pTemplate="item">
            <div class="flex align-items-center gap-2">
              <p-avatar
                [image]="leader.profile_picture | imagePipe : 'user' : 'sm'"
                shape="circle"
              ></p-avatar>
              <div>{{ leader.name }} {{ leader.last_name }}</div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <div class="col-12 md:col">
        <p-button
          styleClass="w-full slide"
          label="Filtra"
          size="small"
          type="submit"
        ></p-button>
      </div>
    </div>
  </form>

  <!--TODO: SCOMMENTARE QUANDO AVREMO IL TESTO-->
  <!-- <div class="mt-7">
    @if(showMoreText){
    <h3 class="m-0 mb-2">{{ content }}</h3>
    }@else {
    <h3 class="m-0 mb-2">{{ content.slice(0, 120) }}...</h3>
    }
    <small (click)="showMoreContent()" class="orange cursor-pointer"
      >Mostra di {{ showMoreText ? "meno" : "più" }}</small
    >
  </div> -->

  @if(loading_page){
  <div class="backdrop-mini-loader">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
  }@else {
  <div class="grid mt-2 mb-10">
    @for (t of travels; track $index) {
    <div class="col-12 md:col-6 lg:col-4 p-3">
      <app-travel-card
        [travel]="t"
        [country]="country"
        [show_organization]="true"
      ></app-travel-card>
    </div>
    }
  </div>

  @if(totalRecords === 0){
  <div class="flex align-items-center justify-content-center mt-7 mb-6">
    <div class="empty-set px-0">
      <img src="/assets/media/illustrations/map.png" height="200" />
      <h5>Nessun risultato</h5>
    </div>
  </div>
  } @if(totalRecords > travels.length){
  <div class="flex align-items-center justify-content-center mt-7">
    <p-button
      label="Mostra altro"
      styleClass="slide px-6"
      size="small"
      (click)="showMore()"
    ></p-button>
  </div>
  } }
</div>

<app-request></app-request>
